export default __webpack_public_path__ + "static/media/hurry_up_3.a4f6cdce.gif";